<template>
    <div class="modal-controls">
        <b-row>
            <b-col cols="12" lg="4" class="align-self-center pr-lg-4">
                {{'purchase_settings' | lang}}:
            </b-col>
            <b-col cols="12" lg="4" class="pt-4 pt-lg-0">
                <AmountPicker :controlsDisabled="controlsDisabled" :onModal="true"> </AmountPicker>
            </b-col>
            <b-col cols="12" lg="4" class="pt-4 pt-lg-0">
                <PaylinePicker :controlsDisabled="controlsDisabled" :onModal="true"> </PaylinePicker>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import AmountPicker from '@sl/base/components/partials/AmountPicker';
import Speed from '@sl/base/components/partials/Speed';
import PaylinePicker from '@sl/base/components/partials/PaylinePicker';
import AutoSpinner from '@sl/base/components/partials/AutoSpinner';
import Message from '@sl/base/components/partials/Message';
import { range } from 'lodash';

export default {
    components: { AmountPicker, PaylinePicker, AutoSpinner, Message, Speed },
    data() {
        return {
            infoActive: false,
            infoContext: undefined,
        };
    },
    computed: {
        ...mapState([
            'relayMethods',
            'freeSpins',
            'ticketInProgress',
            'canvasReady',
            'balance',
            'amountWon',
            'reelSpinning',
            'autoSpins',
            'device',
            'mute',
            'isLogged',
            'mode'
        ]),
        controlsDisabled() {
            return !this.canvasReady || !!this.autoSpins || this.reelSpinning;
        },
        isMobile() {
            return this.device === 'mobile';
        }
    },
    methods: {
        ...mapMutations(['toggleMute', 'setMessage']),
        purchase() {
            if(!this.canvasReady) {
                return;
            }

            this.relayMethods.purchase();
        },

        activateInfo(context) {
            this.infoActive = true;
            this.infoContext = context;
        },
    },
    created: function () {
        if(this.mode === 'real' && !this.isLogged && !Config.replay_id) {
            this.setMessage('please_login');
        }
    }
}
</script>